define 'controller/NewsletterDirectController', ['jquery'], ($) ->
  class NewsletterDirectController
  
    constructor: (@$el) ->
      @_onSubscribeSubmit()

    _onSubscribeSubmit: ->
      self = @
      isRunning = false

      @$el.off 'keyup', '.bloc-newsletter-form--input input'

      @$el.on 'keypress', '.bloc-newsletter-form--input input', (e) ->
        if (e.which == 13)
          e.preventDefault()
          if(!isRunning)
            self.$el.find("form").trigger("submit")

      @$el.on 'keyup', '.bloc-newsletter-form--input input', (e) ->
        if (e.which == 13)
          e.preventDefault()
          if(!isRunning)
            self.$el.find("form").trigger("submit")

      @$el.on 'submit', 'form', (e) ->
        e.preventDefault()
        isRunning = true;
        $form = self.$el.find('form')
        self.$el.find('.bloc-newsletter-form--error').hide()
        email = $form.find('input[type=text],input[type=email]').val()

        if !(self._isEmailValid(email))
          isRunning=false
          self.$el.find('.bloc-newsletter-form--error-format').show()
          return
        $.ajax
          url: $form.attr('action')
          type: $form.attr('method')
          data:
            email: email
          success: ->
            self._pushNewsletterSubscription()
            $('#modalOverlay .modal-body').load $form.data('modal'), ->
              $('#modalOverlay').modal('show')

          error: (error) ->
            if(error.status == 302)
              window.location.href =  '/newsletter/abonnement-confirm?email='  + btoa(unescape(encodeURIComponent(email)))
            else
              self.$el.find('.bloc-newsletter-form--error-technical').show()
          complete: () ->
            $('#loading-overlay').remove()
            isRunning = false


    _pushNewsletterSubscription: ->
      $.ajax({
        url: "/api/datalayer/event/newslettersubscribe",
        type: 'GET',
        success: (data) ->
          if data == undefined
            return
          dataLayer.push(data)
      })

    _isEmailValid: (email) ->
      if email.length < 1
        return false
      regex = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/
      return regex.test(email)

    destroy: ->
      @$el.off()